module.exports = __webpack_public_path__ + "static/media/sara.d644d813.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/sara.png
// module id = 192
// module chunks = 0